export default __webpack_public_path__ + "static/media/solis.a485ea23.png";